import { t } from 'ember-intl';
import { or, eq } from 'ember-truth-helpers';
import { lowercase } from 'ember-cli-string-helpers';
import {
  HdsTable,
  HdsIcon,
} from '@hashicorp/design-system-components/components';
import { Flex } from 'core/components';
import { rbacRoles, optionForSourceState } from 'core/helpers';

const RolesTable = <template>
  <HdsTable
    @caption={{t "components.iam.users.roles-table.roles"}}
    @valign="middle"
    data-test-iam-user-roles-table
    ...attributes
  >
    <:head as |H|>
      <H.Tr>
        <H.Th @width="193px">{{t
            "components.iam.users.roles-table.role"
          }}</H.Th>
        <H.Th @width="193px">{{t
            "components.iam.users.roles-table.scope"
          }}</H.Th>
        <H.Th>{{t "components.iam.users.roles-table.description"}}</H.Th>
      </H.Tr>
    </:head>
    <:body as |B|>
      {{#each @roleLocations as |roleLocation|}}
        <B.Tr data-test-iam-user-roles-table-row>
          {{#let
            (rbacRoles
              roleLocation.roleId active=true type=roleLocation.link.type
            )
            as |rbacRole|
          }}
            <B.Td
              data-test-iam-user-roles-table-cell-role-id={{roleLocation.roleId}}
            >
              {{or rbacRole.label roleLocation.title roleLocation.roleId}}
            </B.Td>
            <B.Td data-test-iam-user-roles-table-cell-scope>
              {{#if (eq (lowercase roleLocation.member.memberType) "group")}}
                {{#let
                  (optionForSourceState
                    "policy-type" roleLocation.member.memberType
                  )
                  as |option|
                }}
                  <Flex @alignItems="start" @direction="row" @gap="xs">
                    <span>
                      <HdsIcon @name={{option.icon}} @isInline={{true}} />
                    </span>
                    <span>{{or
                        roleLocation.group.displayName
                        roleLocation.member.memberId
                      }}</span>
                  </Flex>
                {{/let}}
              {{else}}
                {{#let
                  (optionForSourceState "resource-type" roleLocation.link.type)
                  as |option|
                }}
                  <Flex @alignItems="center" @direction="row" @gap="xs">
                    <span>
                      <HdsIcon @name={{option.icon}} @isInline={{true}} />
                    </span>
                    <span>{{roleLocation.link.name}}</span>
                  </Flex>
                {{/let}}
              {{/if}}
            </B.Td>
            <B.Td data-test-iam-user-roles-table-cell-description>
              {{or rbacRole.description roleLocation.description "—"}}
            </B.Td>
          {{/let}}
        </B.Tr>
      {{/each}}
    </:body>
  </HdsTable>
</template>;
export default RolesTable;
